import { render } from "./GalleryThemeEdit.vue?vue&type=template&id=48d646e4&scoped=true"
import script from "./GalleryThemeEdit.vue?vue&type=script&lang=js"
export * from "./GalleryThemeEdit.vue?vue&type=script&lang=js"

import "./GalleryThemeEdit.vue?vue&type=style&index=0&id=48d646e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d646e4"]])

export default __exports__